import { render } from "./Formato2007.vue?vue&type=template&id=1f2b6066&scoped=true"
import script from "./Formato2007.vue?vue&type=script&lang=js"
export * from "./Formato2007.vue?vue&type=script&lang=js"

import "./Formato2007.vue?vue&type=style&index=0&id=1f2b6066&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2b6066"]])

export default __exports__